import api from "../../api";
import type {
  SearchApiResponse,
  SearchResultData,
} from "../../../@types/portalAluno";
import { mapSearchResponse } from "../../../utils/portalAluno/mappers/searchMapper";

export const SEARCH_MIN_LENGTH = 2;

export const isSearchable = (query: string) =>
  query.trim().length >= SEARCH_MIN_LENGTH;

export const searchContents = async (
  query: string,
  offset = 0
): Promise<SearchResultData> => {
  const trimmedQuery = query.trim();

  if (!isSearchable(trimmedQuery)) {
    return { query: trimmedQuery, sections: [], total: 0 };
  }

  const response = await api.post<SearchApiResponse>("mobile/pesquisar", {
    txtPesquisa: trimmedQuery.toLowerCase(),
    offset,
  });

  return mapSearchResponse(response.data, trimmedQuery);
};
